Ext.define('SA.HistogramChartParams', {
    singleton: true,

    staticCfg: {
        axisLabelOffset: 10,
        barGap: 1,
        chartMaxWidth: 1400,
        chartMinWidth: 850,
        chartPadding: 40,
        heightWidthRatio: 9 / 16,
        titleMaxWidth: 500,
        titleOffset: 25
    },

    get({availableSpace, modelState, data}) {
        var cfg = this.getCfg({availableSpace, modelState});

        return {cfg, data};
    },

    getCfg({availableSpace, modelState}) {
        return {
            bar: {
                gap: this.staticCfg.barGap,
                color: modelState.barColor
            },

            layout: {
                titleMaxWidth: this.staticCfg.titleMaxWidth,
                titleOffset: this.staticCfg.titleOffset,
                chartPadding: this.staticCfg.chartPadding,
                axisLabelOffset: this.staticCfg.axisLabelOffset,
                chartSize: this.resolveChartSize(availableSpace)
            },

            text: {
                chartTitle: modelState.chartTitle,
                yTitle: modelState.yAxisTitle,
                xTitle: modelState.attributes.selected.label,
                xAxisTickLabelFormatter: modelState.attributes.selected.formatter
            }
        };
    },

    resolveChartSize(availableSpace) {
        var aspectConformantSize = SA.restrictSizeByRatio(availableSpace, this.staticCfg.heightWidthRatio),
            width = Ext.Number.constrain(aspectConformantSize.width, this.staticCfg.chartMinWidth, this.staticCfg.chartMaxWidth),
            height = width * this.staticCfg.heightWidthRatio;

        return {width, height};
    }
});